import React, { Fragment } from 'react'
import styles from './SaveSuccess.scss'
import { FancyCheckmark } from 'common/FancyCheckmark'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'
import { urls } from 'lib/urls'
import { Msg, useFormatMessage, featureNames, commonNouns, commonVerbs, commonMessages } from 'lib/localization'
import cx from 'classnames'
import { FormattedMessage as T, defineMessages } from 'react-intl'
import _ from 'lodash'

export const organizedMessages = defineMessages({
  savedTo: {
    id: 'SaveSuccess.savedTo',
    defaultMessage: '<strong>{name}</strong> has been saved to {location}'
  },
  orgLib: {
    id: 'SaveSuccess.orgLib',
    defaultMessage: "<a>{name}</a>'s route library"
  },
  organizedIn: {
    id: 'organizedMessage.organizedIn',
    defaultMessage: 'organized in your {locations}'
  },
  view: {
    id: 'SaveSuccess.view',
    defaultMessage: 'View {asset}'
  }
})

export const SaveSuccess = ({
  troute, organizedInEvents, organizedInExperiences, organizedInClub, objectType, onRequestClose, openInNewTab
}) => {
  const fm = useFormatMessage()
  const location = organizedInClub
    ? <Msg
      m={organizedMessages.orgLib}
      values={{
        a: (...c) => <a href={urls.organizations.routes(organizedInClub.id)}>{c}</a>,
        name: organizedInClub.name
      }} />
    : <T
      id='SaveSuccess.yourThings'
      defaultMessage='your {objectType}'
      values={{ objectType: fm(objectType === 'route' ? commonNouns.routes : commonNouns.trips, { count: 0 }) }} />

  return (
    <ModalOverlay
      maxWidth='600px'
      contentPadding={false}
      title={<div><T
        id='SaveSuccess.savedName'
        defaultMessage='Saved <strong>{name}</strong>'
        values={{
          strong: (...c) => <strong>{c}</strong>,
          name: troute.name
        }} />
      </div>}
      onRequestClose={onRequestClose}
      footer={<Footer troute={troute} objectType={objectType} openInNewTab={openInNewTab} />}>
      <div className={styles.body}>
        <FancyCheckmark />
        <div>
          <Msg
            m={organizedMessages.savedTo}
            values={{
              strong: (...c) => <strong>{c}</strong>,
              name: troute.name,
              location
            }} />
          {organizedInEvents && organizedInEvents.size > 0 && <OrganizedIn
            organizables={organizedInEvents}
            organizableMessage={featureNames.events}
            path={urls.events.show}
            last={!organizedInExperiences || organizedInExperiences.size === 0} />}
          {organizedInExperiences && organizedInExperiences.size > 0 && <OrganizedIn
            organizables={organizedInExperiences}
            organizableMessage={featureNames.experiences}
            path={urls.experiences.edit}
            last />}
        </div>
      </div>
    </ModalOverlay>
  )
}

const OrganizedIn = ({ organizables, organizableMessage, path, last }) => {
  const fm = useFormatMessage()
  return <span>
    {`,${last ? ` ${fm(commonMessages.and)}` : ''} ${fm(organizedMessages.organizedIn, { locations: fm(organizableMessage, { count: organizables.size }) })} `}
    {organizables
      .valueSeq()
      .map((e, k) => <Fragment key={e.id}>
        <a key={e.id} href={path(e.id)}>{e.name}</a>
        {organizables.size > 2 && k < organizables.size - 1 && ', '}
        {organizables.size > 2 && k === organizables.size - 2 && `${fm(commonMessages.and)} `}
        {organizables.size === 2 && (k === 0) && ` ${fm(commonMessages.and)} `}
      </Fragment>)}
  </span>
}

const Footer = ({ troute, objectType, openInNewTab }) => {
  const fm = useFormatMessage()
  const localizedString = fm(objectType === 'route'
    ? commonNouns.routes
    : commonNouns.trips, { count: 1 })

  return (
    <div className={styles.footer}>
      <CTA
        to={`${urls[`${objectType}s`].show(troute.id, troute.privacyCode)}?openShare=true`}
        target={openInNewTab && '_blank'}
        link
        margins={false}
        className={cx(styles.specificity, styles.leftLink)}>
        <Msg m={commonVerbs.share} /> {_.capitalize(localizedString)}
      </CTA>
      {objectType === 'route' && <CTA
        link
        target={openInNewTab && '_blank'}
        margins={false}
        onClick={() => window.location.assign(`/${objectType}s/${troute.id}/send_to_device`)}
        className={cx(styles.specificity, styles.middleLink)}>
        <Msg m={featureNames.sendToDevice} />
      </CTA>}
      <CTA
        to={urls[`${objectType}s`].show(troute.id, troute.privacyCode)}
        target={openInNewTab && '_blank'}
        margins={false}
        className={styles.specificity}>
        <Msg m={organizedMessages.view} values={{ asset: _.capitalize(localizedString) }} />
      </CTA>
    </div>
  )
}
